import * as React from "react";
import { motion } from "framer-motion";
import "./styles.css";
import ThreeDotsWave from "./LoadingDots";

export const PathAnimationLoader = () => (
  <div className="bg-gradient-to-r w-full h-screen flex from-[#fff] to-[#fff] justify-center items-center flex-col">
    <div className="flex justify-center pl-20 items-center overflow-hidden  rounded-xl">
      <motion.svg
        xmlns="http://www.w3.org/2000/svg"
        viewBox="0 0 100 100"
        className="item"
      >
        <motion.path
          d="M 40.2 52 L 0 52 L 0 44.9 L 28.7 7.8 L 0.6 7.8 L 0.6 0 L 39.7 0 L 39.7 6.9 L 11.1 44 L 40.2 44 L 40.2 52 Z"
          initial={{ pathLength: 0, fill: "rgba(255, 255, 255, 0)" }}
          animate={{ pathLength: 1, fill: "#ef6a01" }}
          transition={{
            duration: 5,
            ease: "easeInOut",
            repeat: Infinity,
            repeatType: "loop",
            repeatDelay: 1,
          }}
          strokeWidth={1}
          stroke="#ef6a01"
          strokeDasharray="0 1"
        />
      </motion.svg>
    </div>
    <div className=" flex justify-center items-center lg:-mt-14 -mt-7">
      <div className="flex items-center justify-center">
        <h1 className="text-subMain text-lg">Loading Please Wait</h1>
        <ThreeDotsWave />
      </div>
    </div>
  </div>
);
